
import Vue from 'vue';
import { getAuthToken } from '@/utils/authToken';

interface CategoryItem {
  title: string;
  iconClass: string;
  path?: string;
}

const baseUrl = 'cqcc';

export default Vue.extend({
  name: 'CategorySection',
  data() {
    return {
      categoryList: [
        {
          title: '摄影作品',
          iconClass: 'icon-photo',
          path: `/${baseUrl}/signup/photo`,
        },
        {
          title: '短视频作品',
          iconClass: 'icon-video',
          path: `/${baseUrl}/signup/video`,
        },
        {
          title: '视听设计作品',
          iconClass: 'icon-audio',
          path: `/${baseUrl}/signup/audio`,
        },
        {
          title: '图文报道作品',
          iconClass: 'icon-report',
          path: `/${baseUrl}/signup/report`,
        },
        {
          title: '人工智能生成作品',
          iconClass: 'icon-ai',
          path: `/${baseUrl}/signup/ai`,
        },
      ] as CategoryItem[],
    };
  },
  methods: {
    handleCategoryClick(item: CategoryItem) {
      const target = item.path || `/${baseUrl}/signup`;
      const loginPath = `/${baseUrl}/login`;

      if (!getAuthToken()) {
        this.$router
          .push({
            path: loginPath,
            query: {
              redirect: target,
            },
          })
          .catch((err: Error) => err);
        return;
      }

      this.$router.push(target).catch((err: Error) => err);
    },
  },
});
